import { useEffect, useState } from "react";
import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { FileUploadProvider } from "@common/uploads/uploader/file-upload-provider";
import { FormImageSelector } from "@common/ui/images/image-selector";
import { FormTextField } from "@common/ui/forms/input-field/text-field/text-field";


export default function BasicEditor({
    field
}: any) {

    const [value, setValue] = useState(JSON.parse(field.value ?? "{}"));

    const handleCoverChange = (e : any) => {
        setValue((prevState : any) => ({...prevState, [e.target.name] : e.target.value }));
    };

    useEffect(() => {
        field.onChange(JSON.stringify(value));
    }, [value]);

    return (
        <>
            <div className="mb-12">
                <Typography variant="body2">Avatars : </Typography>
                <FileUploadProvider>
                    <FormImageSelector name="avatar" 
                    showRemoveButton={true}
                    onChange={
                        (value) => {
                            setValue((prevState: any) => ({ ...prevState, avatar: value }));
                        }
                    } diskPrefix="widgets"/>
                </FileUploadProvider>
            </div>
            <div className="mb-12">
                <FormTextField
                    className="mb-24"
                    name="title"
                    label={"Title"}
                    onChange={handleCoverChange}
                />
            </div>
            <div className="mb-12">
                <FormTextField
                    className="mb-24"
                    name="description"
                    label={"Description"}
                    onChange={handleCoverChange}
                />
            </div>
        </>
    );
}